import React, { useState, useEffect } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import {
	NEED_TO_BE_SELECTED,
	displayMetric,
	metricDomain,
	measures,
	productHierarchyType,
	measureList,
	measureListB,
	aggregationList,
	aggregationListB,
	hierarchyArr,
} from '../../constants/constant';
import { Box, useMediaQuery } from '@material-ui/core';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import GroupedMetric from './GroupedMetric';
import storeIcon from '../../assets/SVGs/Vector.svg';
import { useStyles, styles, selectStyleMenu } from './styles';
import AddItem from './AddItems/AddItem';
import ComparisonLocation from './ComparisonLocation';
import { getKeyByValue } from '../../helper/commonUtils';
import PropTypes from 'prop-types';

const getEditData = (arr, key) => {
	return arr.find((obj) => {
		return obj.name === key;
	});
};

const ComparisonAccordions = ({ getData, editRuleData }) => {
	const measureEditValueA = getEditData(
		measureList,
		editRuleData?.left?.measureType
	);
	const measureEditValueB = getEditData(
		measureList,
		editRuleData?.right?.measureType
	);
	const aggregateEditValueA = getEditData(
		aggregationList,
		editRuleData?.left?.aggregationLevel
	);
	const aggregateEditValueB = getEditData(
		aggregationList,
		editRuleData?.right?.aggregationLevel
	);
	const isSmallScreen = useMediaQuery('(max-width:480px)');
	const [metricA, setMetricA] = useState(NEED_TO_BE_SELECTED);
	const [metricB, setMetricB] = useState(NEED_TO_BE_SELECTED);
	const [hierarchyA, setHierarchyA] = useState(
		editRuleData
			? getKeyByValue(
					productHierarchyType,
					editRuleData?.left?.productHierarchyType
			  )
			: NEED_TO_BE_SELECTED
	);
	const [hierarchyB, setHierarchyB] = useState(
		editRuleData
			? getKeyByValue(
					productHierarchyType,
					editRuleData?.right?.productHierarchyType
			  )
			: NEED_TO_BE_SELECTED
	);
	const [measureA, setMeasureA] = useState(
		editRuleData ? measureEditValueA?.name : null
	);
	const [measureB, setMeasureB] = useState(
		editRuleData ? measureEditValueB?.name : null
	);
	const [aggregateA, setAggregateA] = useState(
		editRuleData ? aggregateEditValueA?.name : null
	);
	const [aggregateB, setAggregateB] = useState(
		editRuleData ? aggregateEditValueB?.name : null
	);
	const [iconHierarchyA, setIconHierarchyA] = useState(false);
	const [iconHierarchyB, setIconHierarchyB] = useState(false);
	const [locationData, setLocationData] = useState({});
	const [listA, setListA] = useState({});
	const [listB, setListB] = useState({});

	const classes = useStyles();

	useEffect(() => {
		const data = {
			left: {
				metricDomain: metricDomain[metricA],
				metric: measures[metricA],
				productHierarchyType: productHierarchyType[hierarchyA],
				productFilters: listA?.selectedItems,
				measureType: measureA,
				aggregationLevel: aggregateA,
				status: 'Active',
			},
			right: {
				metricDomainB: metricDomain[metricB],
				metricB: measures[metricB],
				productHierarchyTypeB: productHierarchyType[hierarchyB],
				productFiltersB: listB?.selectedItems,
				measureTypeB: measureB,
				aggregationLevelB: aggregateB,
				statusB: 'Active',
			},
			...locationData,
		};

		getData(data);
	}, [
		metricA,
		metricB,
		hierarchyA,
		hierarchyB,
		measureA,
		measureB,
		aggregateA,
		aggregateB,
		locationData,
		listA,
		listB,
	]);

	const handleMetricChangeA = (label) => {
		setMetricA(label);
	};
	const handleMetricChangeB = (label) => {
		setMetricB(label);
	};

	const handleHierarchyChangeA = (event) => {
		if (hierarchyA) {
			getStoreSelectionA({});
		}
		setHierarchyA(event.target.value);
	};
	const handleHierarchyChangeB = (event) => {
		if (hierarchyB) {
			getStoreSelectionB({});
		}
		setHierarchyB(event.target.value);
	};
	const handleMeasureChangeA = (event) => {
		setMeasureA(event.target.value);
		setMeasureB(event.target.value);
	};
	const handleMeasureChangeB = (event) => {
		handleMeasureChangeA(event);
	};
	const handleAggregateChangeA = (event) => {
		setAggregateA(event.target.value);
		setAggregateB(event.target.value);
	};
	const handleAggregateChangeB = (event) => {
		handleAggregateChangeA(event);
	};

	const hierarchyAClick = () => {
		setIconHierarchyA(true);
	};

	const hierarchyBClick = () => {
		setIconHierarchyB(true);
	};

	const getLocationData = (data) => {
		setLocationData(data);
	};

	const getStoreSelectionA = (list) => {
		setListA(list);
	};

	const getStoreSelectionB = (list) => {
		setListB(list);
	};

	const measureArrA = [
		'Store In InStock %',
		'Nil Pick Rate %',
		'Pre substitute Rate %',
		'Post substitute Rate %',
		'First-time Pick Rate %',
	].includes(displayMetric[metricA])
		? measureListB
		: measureList;

	const measureArrB = [
		'Store In InStock %',
		'Nil Pick Rate %',
		'Pre substitute Rate %',
		'Post substitute Rate %',
		'First-time Pick Rate %',
	].includes(displayMetric[metricB])
		? measureListB
		: measureList;

	const aggregationArrA = ['WOW_CHANGE', 'WOW_CHANGE_PERCENTAGE'].includes(
		measureA
	)
		? aggregationListB
		: aggregationList;

	const aggregationArrB = ['WOW_CHANGE', 'WOW_CHANGE_PERCENTAGE'].includes(
		measureB
	)
		? aggregationListB
		: aggregationList;

	const borderTopStyle = '1px solid lightgray';

	const hierarchyTxtA = `${hierarchyA} ${
		listA?.selectedItems?.length ? `, multiple ${hierarchyA} selected` : ''
	}`;

	const hierarchyTxtB = `${hierarchyB} ${
		listB?.selectedItems?.length ? `, multiple ${hierarchyB} selected` : ''
	}`;

	return (
		<Box className={classes.metricBox}>
			{!isSmallScreen && (
				<Grid container>
					<Grid item xs={12} sm={6} md={6} lg={6}>
						<Typography className={classes.A}>A</Typography>
					</Grid>
					<Grid item xs={12} sm={6} md={6} lg={6}>
						<Typography className={classes.A}>B</Typography>
					</Grid>
				</Grid>
			)}
			<Accordion
				elevation={0}
				classes={{
					root: classes.MuiAccordionroot,
				}}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel2a-content"
					id="panel2a-header"
					sx={{ borderTop: borderTopStyle }}>
					<Grid container>
						{[metricA, metricB]?.map((item, key) => {
							return (
								<Grid item xs={12} sm={6} md={6} lg={6} key={key}>
									<Box
										className={classes.boxStyle}
										style={key === 1 ? { marginLeft: '15px' } : {}}>
										<>
											<Typography className={classes.menuItems}>
												Metric
											</Typography>
											<Typography
												className={classes.menuItems}
												style={{ fontSize: 12, paddingTop: '6px' }}>
												{item !== NEED_TO_BE_SELECTED
													? displayMetric[item]
													: item}
											</Typography>
										</>
									</Box>
								</Grid>
							);
						})}
					</Grid>
				</AccordionSummary>
				<AccordionDetails>
					<Grid container>
						{isSmallScreen && (
							<Grid item xs={12}>
								<Typography className={classes.menuItemsType}>A</Typography>
							</Grid>
						)}
						<Grid item xs={12} sm={6} md={6} lg={6}>
							<FormControl
								sx={{ ...styles.comMetricSelect, ...styles.outline }}>
								<GroupedMetric
									getValue={handleMetricChangeA}
									defaultValue={editRuleData?.left?.metric}
									isEditFlow={editRuleData}
								/>
							</FormControl>
						</Grid>
						{isSmallScreen && (
							<Grid item xs={12}>
								<Typography className={classes.menuItemsType}>B</Typography>
							</Grid>
						)}
						<Grid item xs={12} sm={6} md={6} lg={6}>
							<FormControl
								sx={{ ...styles.comMetricSelect, ...styles.outline }}>
								<GroupedMetric
									getValue={handleMetricChangeB}
									selectedA={metricA}
									defaultValue={editRuleData?.right?.metric}
									isEditFlow={editRuleData}
								/>
							</FormControl>
						</Grid>
					</Grid>
				</AccordionDetails>
			</Accordion>

			<ComparisonLocation
				metricA={metricA}
				metricB={metricB}
				getLocationData={getLocationData}
				editRuleData={editRuleData}
			/>

			<Accordion
				elevation={0}
				classes={{
					root: classes.MuiAccordionroot,
				}}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="hierarchy-content"
					id="hierarchy-header"
					sx={{ borderTop: borderTopStyle }}>
					<Grid container>
						<Grid item xs={12} sm={6} md={6} lg={6}>
							<Box className={classes.boxStyle}>
								<Typography className={classes.menuItems}>
									Product Hierarchy
								</Typography>
								{!isSmallScreen && (
									<Typography
										className={classes.menuItems}
										style={{ fontSize: 12, paddingTop: '6px' }}>
										{hierarchyTxtA}
									</Typography>
								)}
							</Box>
						</Grid>
					</Grid>
					{!isSmallScreen && (
						<Grid container>
							<Grid item xs={12} sm={6} md={6} lg={6}>
								<Box
									className={classes.boxStyle}
									style={{ marginLeft: '15px' }}>
									<Typography className={classes.menuItems}>
										Product Hierarchy
									</Typography>
									<Typography
										className={classes.menuItems}
										style={{ fontSize: 12, paddingTop: '6px' }}>
										{hierarchyTxtB}
									</Typography>
								</Box>
							</Grid>
						</Grid>
					)}
				</AccordionSummary>
				<AccordionDetails>
					<Grid container>
						{isSmallScreen && (
							<>
								<Grid item xs={12}>
									<Typography className={classes.menuItemsType}>A</Typography>
								</Grid>
								<Grid>
									<Typography
										className={classes.menuItems}
										style={{ fontSize: 12, paddingTop: '6px' }}>
										{hierarchyTxtA}
									</Typography>
								</Grid>
							</>
						)}
						<Grid item xs={12} sm={6} md={6} lg={6}>
							<FormControl
								sx={{ ...styles.comMetricSelect, ...styles.outline }}>
								<InputLabel id="hierarchy-label" sx={{ ...styles.textField }}>
									Hierarchy
								</InputLabel>
								<Select
									id="Hierarchy"
									value={hierarchyA}
									label="Hierarchy"
									onChange={handleHierarchyChangeA}
									MenuProps={{
										sx: selectStyleMenu,
										disablePortal: true,
									}}>
									{hierarchyArr?.map((name) => (
										<MenuItem
											key={name}
											value={name}
											className={classes.menuItems}>
											{name}
										</MenuItem>
									))}
								</Select>
							</FormControl>
							{hierarchyA !== NEED_TO_BE_SELECTED && (
								<Box
									style={{
										marginTop: '20px',
										marginLeft: '2px',
										display: 'flex',
										alignItems: 'center',
										cursor: 'pointer',
									}}
									onClick={hierarchyAClick}>
									<img alt="storeIcon" src={storeIcon} />
									<span style={{ marginLeft: '10px' }}> Add {hierarchyA}</span>
								</Box>
							)}
						</Grid>
						{isSmallScreen && (
							<>
								<Grid item xs={12}>
									<Typography className={classes.menuItemsType}>B</Typography>
								</Grid>
								<Grid>
									<Typography
										className={classes.menuItems}
										style={{ fontSize: 12, paddingTop: '6px' }}>
										{hierarchyTxtB}
									</Typography>
								</Grid>
							</>
						)}
						<Grid item xs={12} sm={6} md={6} lg={6}>
							<FormControl
								sx={{ ...styles.comMetricSelect, ...styles.outline }}>
								<InputLabel id="hierarchy-label" sx={{ ...styles.textField }}>
									Hierarchy
								</InputLabel>
								<Select
									id="Hierarchy"
									value={hierarchyB}
									label="Hierarchy"
									onChange={handleHierarchyChangeB}
									MenuProps={{
										sx: selectStyleMenu,
										disablePortal: true,
									}}>
									{hierarchyArr?.map((name) => (
										<MenuItem
											key={name}
											value={name}
											className={classes.menuItems}>
											{name}
										</MenuItem>
									))}
								</Select>
							</FormControl>
							{hierarchyB !== NEED_TO_BE_SELECTED && (
								<Box
									style={{
										marginTop: '20px',
										marginLeft: '2px',
										display: 'flex',
										alignItems: 'center',
										cursor: 'pointer',
									}}
									onClick={hierarchyBClick}>
									<img alt="storeIcon" src={storeIcon} />
									<span style={{ marginLeft: '10px' }}> Add {hierarchyB}</span>
								</Box>
							)}
						</Grid>
					</Grid>
				</AccordionDetails>
			</Accordion>

			<Accordion
				elevation={0}
				classes={{
					root: classes.MuiAccordionroot,
				}}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="timerange-content"
					id="timerange-header"
					sx={{ borderTop: borderTopStyle }}>
					<Grid container>
						<Grid item xs={12} sm={6} md={6} lg={6}>
							<Box className={classes.boxStyle}>
								<Typography className={classes.menuItems}>
									Time Range
								</Typography>
								{!isSmallScreen && (
									<Typography
										className={classes.menuItems}
										style={{ fontSize: '12px', paddingTop: '6px' }}>
										{measureA && aggregateA
											? `${measureA}, ${aggregateA}`
											: NEED_TO_BE_SELECTED}
									</Typography>
								)}
							</Box>
						</Grid>
						{!isSmallScreen && (
							<Grid item xs={12} sm={6} md={6} lg={6}>
								<Box
									className={classes.boxStyle}
									style={{ marginLeft: '15px' }}>
									<Typography className={classes.menuItems}>
										Time Range
									</Typography>
									<Typography
										className={classes.menuItems}
										style={{ fontSize: '12px', paddingTop: '6px' }}>
										{measureB && aggregateB
											? `${measureB}, ${aggregateB}`
											: NEED_TO_BE_SELECTED}
									</Typography>
								</Box>
							</Grid>
						)}
					</Grid>
				</AccordionSummary>
				<AccordionDetails>
					<Grid container>
						{isSmallScreen && (
							<>
								<Grid item xs={12}>
									<Typography className={classes.menuItemsType}>A</Typography>
								</Grid>
								<Grid>
									<Typography
										className={classes.menuItems}
										style={{ fontSize: '12px', paddingTop: '6px' }}>
										{measureA && aggregateA
											? `${measureA}, ${aggregateA}`
											: NEED_TO_BE_SELECTED}
									</Typography>
								</Grid>
							</>
						)}
						<Grid item xs={12} sm={6} md={6} lg={6}>
							<FormControl
								sx={{ ...styles.comMetricSelect, ...styles.outline }}>
								<InputLabel
									id="simple-select-helper-label"
									sx={{ ...styles.textField }}>
									Measure
								</InputLabel>
								<Select
									id="measure-basic"
									value={measureA}
									label="Measure"
									onChange={handleMeasureChangeA}
									MenuProps={{
										sx: selectStyleMenu,
										disablePortal: true,
									}}>
									{measureArrA?.map((data) => (
										<MenuItem
											key={data?.name}
											value={data?.name}
											className={classes.menuItems}>
											{data?.value}
										</MenuItem>
									))}
								</Select>
							</FormControl>

							<FormControl
								sx={{ ...styles.comMetricSelect, ...styles.outline }}
								style={{ marginTop: '30px' }}>
								<InputLabel
									id="simple-select-helper-label"
									sx={{ ...styles.textField }}>
									Aggregate
								</InputLabel>

								<Select
									id="aggregate-basic"
									value={aggregateA}
									label="Aggregate"
									onChange={handleAggregateChangeA}
									MenuProps={{
										sx: selectStyleMenu,
										disablePortal: true,
									}}>
									{aggregationArrA?.map((data) => (
										<MenuItem
											key={data?.name}
											value={data?.name}
											className={classes.menuItems}>
											{data?.value}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
						{isSmallScreen && (
							<>
								<Grid item xs={12}>
									<Typography className={classes.menuItemsType}>B</Typography>
								</Grid>
								<Grid>
									<Typography
										className={classes.menuItems}
										style={{ fontSize: '12px', paddingTop: '6px' }}>
										{measureB && aggregateB
											? `${measureB}, ${aggregateB}`
											: NEED_TO_BE_SELECTED}
									</Typography>
								</Grid>
							</>
						)}
						<Grid item xs={12} sm={6} md={6} lg={6}>
							<FormControl
								sx={{ ...styles.comMetricSelect, ...styles.outline }}>
								<InputLabel
									id="simple-select-helper-label"
									sx={{ ...styles.textField }}>
									{measureB ? '' : 'Measure'}
								</InputLabel>
								<Select
									id="measure-basic"
									value={measureB}
									label="Measure"
									onChange={handleMeasureChangeB}
									MenuProps={{
										sx: selectStyleMenu,
										disablePortal: true,
									}}>
									{measureArrB?.map((data) => (
										<MenuItem
											key={data?.name}
											value={data?.name}
											className={classes.menuItems}>
											{data?.value}
										</MenuItem>
									))}
								</Select>
							</FormControl>

							<FormControl
								sx={{ ...styles.comMetricSelect, ...styles.outline }}
								style={{ marginTop: '30px' }}>
								<InputLabel
									id="simple-select-helper-label"
									sx={{ ...styles.textField }}>
									{aggregateB ? '' : 'Aggregate'}
								</InputLabel>
								<Select
									id="aggregate-basic"
									value={aggregateB}
									label="Aggregate"
									onChange={handleAggregateChangeB}
									MenuProps={{
										sx: selectStyleMenu,
										disablePortal: true,
									}}>
									{aggregationArrB?.map((data) => (
										<MenuItem
											key={data?.name}
											value={data?.name}
											className={classes.menuItems}>
											{data?.value}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
					</Grid>
				</AccordionDetails>
			</Accordion>

			<AddItem
				isOpen={iconHierarchyA ? true : false}
				type={hierarchyA === NEED_TO_BE_SELECTED ? 'Item' : hierarchyA}
				setIsAddItemsOpen={setIconHierarchyA}
				getData={getStoreSelectionA}
				isComparison={'A'}
			/>
			<AddItem
				isOpen={iconHierarchyB ? true : false}
				type={hierarchyB === NEED_TO_BE_SELECTED ? 'Item' : hierarchyB}
				setIsAddItemsOpen={setIconHierarchyB}
				getData={getStoreSelectionB}
				isComparison={'B'}
			/>
		</Box>
	);
};

ComparisonAccordions.propTypes = {
	getData: PropTypes.func,
	editRuleData: PropTypes.object,
};

export default ComparisonAccordions;
